module.exports = __webpack_public_path__ + "DejaVuSans-BoldOblique.e5947ee873600dd1cae2.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/DejaVu/DejaVuSans-BoldOblique.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/fonts/DejaVu/DejaVuSans-BoldOblique.ttf?v=1.1
// module chunks = styles